<template lang="html">
  <v-app>
    <section class="product">
      <div class="product_page page-bottom" key="product_page">
        <h1>商品情報</h1>
        <h2>タイトル：雪ん娘大旋風 ～さゆきとこゆきのひえひえ大騒動～</h2>
        <div class="text-column product-column">
          <p>発売日：2023年1月19日</p>
          <p>価格： 3,980円（税抜）</p>
          <p>プラットフォーム：NintendoSwitch</p>
          <p>ジャンル：アクションシューティング</p>
          <p>プレイ人数：1～2人</p>
          <p>CERO：A</p>
        </div>
        <SpCont />
      </div>
    </section>
  </v-app>
</template>
<style></style>
<script>
  import SpCont from "./SpecialCont.vue";

  export default {
    components: {
      SpCont,
    },
  };
</script>
